import { isDefined } from '@aloft/toolkit-shared';

import { BreakdownColumn, Tkv2PairedCostSummaryInterfaceV2, isSubRows } from '../types.ts';
import { getValueForColumn } from './getValueForColumn.ts';

export function getTableData(
  tableDef: BreakdownColumn[],
  summary: Tkv2PairedCostSummaryInterfaceV2,
  compSequence: string[],
): { [key: string]: unknown[] } {
  const tableData: { [key: string]: unknown[] } = {};
  const ids = ['subject', ...compSequence];

  for (const id of ids) {
    const row: unknown[] = [];

    for (const col of tableDef) {
      if (isSubRows(col)) {
        const r = col.subRows
          .map((subRow) => {
            if (subRow.shouldShowForProperty(summary, id)) {
              return [
                subRow.label,
                ...subRow.columns.map((subCol) => getValueForColumn(summary, id, subCol)),
              ];
            }
          })
          .filter(isDefined);

        row.push(r);
      } else {
        row.push(getValueForColumn(summary, id, col));
      }
    }

    tableData[id] = row;
  }

  return tableData;
}
